// Single source of truth for tools/links that are not built yet. They are
// hidden from the nav and from Home, but their routes still exist so they stay
// reachable by URL. To bring one back once it ships, delete its key here (one
// line) and it reappears everywhere it was hidden.
export const NOT_BUILT = new Set<string>([
  'comms',
  'schedule',
  'cameras',
  'store-photos',
  'store-gmail',
]);

export const isBuilt = (key: string): boolean => !NOT_BUILT.has(key);
